<main>
    <section class="flex justify-between items-center mb-6">
        <h1 class="text-2xl font-bold text-gray-800">Roles y permisos</h1>
        <add-button label="Nuevo rol" (onClick)="openCreate()"></add-button>
    </section>

    @if(loading) {
    <div class="flex justify-center py-12">
        <span class="text-slate-400">Cargando...</span>
    </div>
    } @else if(roles.length === 0) {
    <div class="text-center py-12 text-slate-400">
        No hay roles creados para esta empresa
    </div>
    } @else{
    <div class="space-y-3">
        @for (role of roles; track role.id) {
        <div class="bg-white rounded-xl border border-slate-200 shadow-sm p-5 flex items-center gap-4">

            <div class="flex-1 min-w-0">
                <p class="font-semibold text-slate-800">{{ role.name }}</p>
                @if (role.description) {
                <p class="text-sm text-slate-500 mt-0.5">{{ role.description }}</p>
                }
                <p class="text-xs text-slate-400 mt-1">
                    {{ role.panels?.length ?? 0 }} panel(es) asignado(s)
                </p>
            </div>

            <div class="flex items-center gap-2 shrink-0">
                <button (click)="openPanels(role)"
                    class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-slate-100 rounded-lg hover:bg-slate-200 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    Permisos
                </button>

                <button (click)="openEdit(role)"
                    class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Editar
                </button>

                <button (click)="openDelete(role)"
                    class="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-red-600 bg-red-50 rounded-lg hover:bg-red-100 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Eliminar
                </button>
            </div>

        </div>
        }
    </div>
    }
</main>
